
import { Component, Vue, Prop } from 'vue-property-decorator';
import { FieldType } from '@/shared/types/aperTemplate';
import type { Field } from '@/shared/types/aperTemplate';

@Component
export default class MultiFieldPreview extends Vue {
  @Prop({ type: Object, required: true }) readonly field!: Field;

  FieldType = FieldType;
}
